export var SPACING_UNIT = 8;
export var SPACING_REGULAR = 16;
export var SPACING_LARGE = 32;
export var SPACING_HUGE = 40;
